import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule, MmFormFieldModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';
import { KebabCaseModule } from '~shared/pipes';
import { SeoModule } from '~shared/modules/seo/seo.module';
import { AppProductCarouselModule } from '~shared/components/app-product-carousel/app-product-carousel.module';
import { CategoryCarouselModule } from '~shared/modules/category-carousel/category-carousel.module';
import { CatalogProductsListModule } from '~shared/modules/catalog';

import {
  RichContentWrapperComponent,
  BannerImageWrapperComponent,
  CustomLinkedComponent,
  ContentCardListComponent,
  ContentCardComponent,
  CategoryGridComponent,
  HeroBannerComponent,
  ColumnContentWrapperComponent,
  ContentProductCarouselComponent,
  CustomSignUpComponent,
  HeadLineBannerComponent,
  SubCategoryGridComponent,
  SubCategoryCardComponent,
  SubCategoryGridWrapperComponent,
  UspGridComponent,
  UspCardComponent,
  BrandListComponent,
  BrandListWrapperComponent,
  AdvancedCarouselComponent,
  TitleCarouselComponent,
  TextboxCarouselComponent,
  BannerCarouselComponent,
  ProductAdvancedCarouselComponent,
  BrandNamesComponent,
  BrandLogosComponent,
  SeoContentWrapperComponent,
  CategoryCarouselWrapperComponent,
  CategoryProductsCatalogWrapperComponent,
  PopularLinksComponent,
  PopularLinksMobileComponent,
  PopularLinksDesktopComponent,
  PopularLinksCardComponent,
  AdvancedCarouselSkeletonComponent,
  SponsoringWrapperComponent,
  SponsoringTooltipComponent,
  SponsoringOverlayComponent,
} from './components';
import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';
import { ImageHeaderModule } from '~shared/components/image-header/image-header.module';
import { CommonModule } from '@angular/common';
import { StoryblokEditableModule, DisableClickEventModule } from '~app/modules/storyblok/directives';
import { StoreModule } from '@ngrx/store';
import { STORYBLOK_FEATURE_NAME } from './store/feature-name';
import { reducers, StoryblokGlobalContentEffects } from './store';
import { EffectsModule } from '@ngrx/effects';
import { MatIconModule } from '@angular/material/icon';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';
import { RouterModule } from '@angular/router';
import { ChevronRightModule } from '~shared/svgs/chevron-right/chevron-right.module';
import { ChevronLeftModule } from '~shared/svgs/chevron-left/chevron-left.module';
import { DynamicModule } from 'ng-dynamic-component';
import { DividerComponent } from './components/divider/divider.component';
import { TeaserComponent } from './components/content-product-carousel/teaser/teaser.component';
import { DynamicSizeModule } from './components/content-product-carousel/dynamicSize/dynamicSize.module';
import { CategoryBubbleModule } from '~shared/components/category-bubble/category-bubble.module';
import { SkewClipPathModule } from '~shared/directives/skewClipPath/skewClipPath.module';
import { SanitizeModule } from '~shared/pipes/sanitaze/sanitaze.module';
import { SwipeModule } from '~shared/directives/swipe/swipe.module';
import { ProductCardModule } from '~shared/modules/product-card/product-card.module';
import { StoryblokSeoModule } from '~shared/modules/storyblok-seo/storyblok-seo.module';
import { NewsletterWrapperComponent } from '~app/modules/storyblok/components';
import { NewsletterSubscriptionModule } from '~shared/modules/newsletter-subscription/newsletter-subscription.module';
import { RelatedCategoriesComponent } from '~app/modules/storyblok/components/related-categories';
import { RelatedCategoryCardComponent } from '~app/modules/storyblok/components/related-categories/components/related-category-card/related-category-card.component';
import { RelatedCategoriesGridComponent } from '~app/modules/storyblok/components/related-categories/components/related-categories-grid/related-categories-grid.component';

import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DesktopSwipeModule } from '~shared/directives/desktopSwipe/desktopSwipe.module';

@NgModule({
  declarations: [
    BannerImageWrapperComponent,
    ContentProductCarouselComponent,
    RichContentWrapperComponent,
    CustomLinkedComponent,
    ContentCardListComponent,
    ContentCardComponent,
    CategoryGridComponent,
    HeroBannerComponent,
    ColumnContentWrapperComponent,
    DividerComponent,
    TeaserComponent,
    CustomSignUpComponent,
    HeadLineBannerComponent,
    SubCategoryGridComponent,
    SubCategoryCardComponent,
    SubCategoryGridWrapperComponent,
    UspGridComponent,
    UspCardComponent,
    BrandListComponent,
    BrandListWrapperComponent,
    BrandNamesComponent,
    BrandLogosComponent,
    ProductAdvancedCarouselComponent,
    AdvancedCarouselComponent,
    TitleCarouselComponent,
    TextboxCarouselComponent,
    BannerCarouselComponent,
    NewsletterWrapperComponent,
    SeoContentWrapperComponent,
    CategoryCarouselWrapperComponent,
    CategoryProductsCatalogWrapperComponent,
    PopularLinksComponent,
    PopularLinksMobileComponent,
    PopularLinksDesktopComponent,
    PopularLinksCardComponent,
    RelatedCategoriesComponent,
    RelatedCategoryCardComponent,
    RelatedCategoriesGridComponent,
    AdvancedCarouselSkeletonComponent,
    SponsoringWrapperComponent,
    SponsoringTooltipComponent,
    SponsoringOverlayComponent,
  ],
  providers: [],
  imports: [
    CommonModule,
    AppProductCarouselModule,
    StoreModule.forFeature(STORYBLOK_FEATURE_NAME, reducers),
    EffectsModule.forFeature([StoryblokGlobalContentEffects]),
    SeoModule,
    StoryblokSeoModule,
    MmFlexLayoutModule,
    TranslateModule,
    QaLocatorsModule,
    KebabCaseModule,
    FlexModule,
    MmExpansionModule,
    ImageHeaderModule,
    StoryblokEditableModule,
    DisableClickEventModule,
    MatIconModule,
    CarouselModule,
    MmIconModule,
    DefaultImageModule,
    LazyLoadImageModule,
    DynamicSizeModule,
    RouterModule,
    ChevronRightModule,
    ChevronLeftModule,
    DynamicModule,
    MmButtonModule,
    MmFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    CategoryBubbleModule,
    SkewClipPathModule,
    SanitizeModule,
    ProductCardModule,
    SwipeModule,
    DesktopSwipeModule,
    NewsletterSubscriptionModule,
    CategoryCarouselModule,
    CatalogProductsListModule,
    IsVisibleModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [NewsletterWrapperComponent, SponsoringWrapperComponent],
})
export class StoryblokModule {}
